module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6Y0QN"))).then(() => module.bundle.root('1iHdE'));